<template>
  <div>
    <!----------------- Main contents Area --------------------->
    <!-- mt-3: margin top-3 -->
    <main class="mt-3">
      <div class="container">

        <!-- 내부공지용 팝업모달 -->
        <NoticeModal
          v-for="(modal, idx) in noticeModals"
          :key="modal.id"
          :content="modal.content"
          :idx="idx"
          @close="handleNoticeClose(idx)"
        />

        <div class="card mx-auto" style="width: 18rem;">
          <img src="../assets/img/b2bLogin.jpg" class="card-img-top">
          <div class="card-body">
            <!-- <h5 class="card-title"></h5> -->
            <form>
              <div class="form-floating mt-3">
                <input type="text" class="form-control" placeholder="id" v-model="bId" ref="txt_bId">
                <label for="floatingInput">Admin-ID</label>
              </div>
              <div class="form-floating mt-2">
                <input type="password" class="form-control" id="floatingPassword" placeholder="Password" v-model="bPass" ref="txt_bPass">
                <label for="floatingPassword">Password</label>
              </div>
              <button class="w-100 btn btn-lg btn-primary mt-3" type="button" ref="enterBtn" @click="loginCheck">Log-In</button>
            </form>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import NoticeModal from '@/components/NoticeModal.vue';

export default {
  components: { NoticeModal },
  data() {
    return {
      loginInfo: [],
      // 다중모달표시를 위한 배열
      noticeModals: [],

      // 페이지 이동을 위한 플래그
      shouldNavigate: false,
      navigationTarget: ''      
    }
  },
  computed: {
    user() {
      // 리턴정보가 바뀔 때마다 user()안에 넣어준다
      // 로그인전: bId정보없음, 로그인후: bId정보있음
      return this.$store.state.user;
    }
  }, 
  create() {
    this.user = this.$store.state.user;
  },

  mounted() {
    if(this.user.handlerId == undefined) 
    {
      document.getElementById("admin").style.display = "none";
    }

    document.addEventListener("keydown",this.handleEnterKeyPress);

    ////document.getElementById("notice").style.display = "none";
    document.getElementById("user").style.display = "none";
    document.getElementById("footer-pc").style.display = "none";
    document.getElementById("footer-m").style.display = "none";
  },
  beforeUnmount() {
    document.removeEventListener("keydown",this.handleEnterKeyPress);
  },
  watch: {
    // noticeModals 배열을 감시하여 모든 팝업이 닫혔을 때 페이지 이동
    noticeModals: {
      handler(newVal) {
        if (this.shouldNavigate && newVal.length === 0) {
          this.navigateToTarget();
        }
      },
      deep: true
    }
  },  
  methods: {
    getDateFormat(date) {
      return this.$dateFormat(date);
    },
    //한국시간대로 변경
    getKorDateFormat(date) {
      return this.$korDateFormat(date)
    },

    handleEnterKeyPress(event)
    {
      if(event.keyCode === 13)
      {
        this.$refs.enterBtn.click();
      }
    },

    // 페이지 이동 처리 메서드
    handleNavigation() {
      if (this.noticeModals.length === 0) 
      {
        // 공지사항이 없으면 즉시 페이지 이동
        this.navigateToTarget();
      } 
      else 
      {
        // 공지사항이 있으면 모든 팝업이 닫힐 때까지 대기
        this.shouldNavigate = true;
      }
    },

    // 실제 페이지 이동 실행
    navigateToTarget() {
      this.shouldNavigate = false;
      this.$router.push(this.navigationTarget);
    },

    async loginCheck() 
    {
      const today_tmp = dayjs();
      let today_kor = this.getKorDateFormat(today_tmp)
      let today_date = today_tmp.format('YYYY-MM-DD')
      let today_time = today_tmp.format('HH:mm:ss')

      let loginInfo = await this.$api("/api/checkLogin", {param: [ this.bId ]});
      this.loginInfo = loginInfo;
      //console.log("loginInfo:",loginInfo);

      if(loginInfo.length <= 0) 
      {
        this.$refs.txt_bId.select();
        //var swal = require('sweetalert2');
        this.$swal.fire({
          text: 'ID를 확인해 주세요',
          icon: 'error'
        });
        // this.$router.push({path: '/'});
      }
      else
      {
        console.log("bPass:", this.bPass);
        loginInfo.forEach(async loginInfo=>{
          if(loginInfo.handlerPass === this.bPass) 
          {
            // 로그인 로그생성
            await this.$api("/api/ins_LoginLog", {param: [ loginInfo.handlerId, today_date, today_time, 'Y' ]})

            // 기출근여부 체크
            let alreadyAttStart = await this.$api("/api/checkDubAttStart", { param: [loginInfo.handlerId] })
            
            //출근(최초로그인)
            if(alreadyAttStart.length < 1)
            {
              this.$swal.fire({
                icon: 'question',
                html: '출근이신가요?',
                showCancelButton: true,
                inputLabel: '▼특기사항(선택, 100자 이내)',
                input: 'text',
                confirmButtonText: '네, 출근입니다',
                cancelButtonText: '아니요, 로그인만 합니다',
                draggable: true,
              })
              .then(async (result) => {
                if(result.isConfirmed)
                {
                  let atCode = "SC"
                  let atUseFlag = "Y"
                  let attFlag = 'IN'                     //IN: 로그인, OUT: 로그아웃
                  let atRemarks_cl = ""                  // 퇴근특기사항
                  let atRemarks_st = result.value || ""; // 입력된 출근특기사항
                  
                  let login_attendance = await this.$api("/api/proc_createAttendance", { param: [
                    loginInfo.handlerId, atCode, atUseFlag, attFlag, atRemarks_st, atRemarks_cl
                  ]})
                  //console.log("login_attendance::::::", login_attendance)
                  
                  if(login_attendance[0][0].v_affectedRows == 1)
                  {
                    this.$swal.fire("", `안녕하세요? ${loginInfo.handlerNameKor}님, 오늘도 수고하세요^^<br>출근일시는 <span class='text-primary'>${today_kor}</span>입니다.`, "success")
                    .then(async () => {
                      // 로그인 & 세션 처리
                      this.$api("/api/loginB2B", {
                        param: [
                          //bId: 접속자ID, bName: 접속자이름, bGrade: 작업레벨, admin: loginInfo.admin, alimCall: loginInfo.alimCall
                          { bId: loginInfo.handlerId, bName: loginInfo.handlerNameKor, bGrade: loginInfo.handlerGrade, alimCall: loginInfo.alimCall, 
                          divCode: loginInfo.divCd, compCode: loginInfo.compCode}
                        ]
                      });
                      this.$store.commit("user", loginInfo);
                      localStorage.setItem('sessionExpiration', new Date().getTime() + ((60 * 60)*12) * 1000);

                      // 1. checkNotice() 실행 및 완료 대기
                      await this.checkNotice();

                      // 2. 네비게이션 타겟 설정 후 조건부 페이지 이동
                      this.navigationTarget = '/reserveInfoList_admin';
                      this.handleNavigation();
                      
                      // // 2. 팝업이 있을 경우 10초 대기
                      // if (this.noticeModals.length > 0) {
                      //   await new Promise(resolve => setTimeout(resolve, 10000));
                      // }
                      
                      // // 3. 페이지 전환
                      // this.$router.push('/reserveInfoList_admin');
                    })
                  }
                  else
                  {
                    this.$swal.fire("", "로그인 정보생성에 오류가 발생했습니다<br>재로그인을 해주세요", "warning")
                    location.reload(true)
                  }
                }
                else
                {
                  this.$swal.fire("", `안녕하세요? ${loginInfo.handlerNameKor} 님, 오늘도 수고하세요^^`, "success")
                  .then(async () => {
                    // 로그인 & 세션 처리
                    this.$api("/api/loginB2B", {
                      param: [
                        //bId: 접속자ID, bName: 접속자이름, bGrade: 작업레벨, admin: loginInfo.admin, alimCall: loginInfo.alimCall
                        { bId: loginInfo.handlerId, bName: loginInfo.handlerNameKor, bGrade: loginInfo.handlerGrade, alimCall: loginInfo.alimCall, 
                        divCode: loginInfo.divCd, compCode: loginInfo.compCode}
                      ]
                    });
                    this.$store.commit("user", loginInfo);
                    localStorage.setItem('sessionExpiration', new Date().getTime() + ((60 * 60)*12) * 1000);

                    // 1. checkNotice() 실행 및 완료 대기
                    await this.checkNotice();

                    // 2. 네비게이션 타겟 설정 후 조건부 페이지 이동
                    this.navigationTarget = '/reserveInfoList_admin';
                    this.handleNavigation();                    
                    // // 2. 팝업이 있을 경우 10초 대기
                    // if (this.noticeModals.length > 0) {
                    //   await new Promise(resolve => setTimeout(resolve, 10000));
                    // }
                    
                    // // 3. 페이지 전환
                    // this.$router.push('/reserveInfoList_admin');
                  })
                }
              })
            }
            //기출근 후 로그인
            else
            {
              this.$swal.fire("", `안녕하세요? ${loginInfo.handlerNameKor} 님, 오늘도 수고하세요^^`, "success")
              .then(async () => {
                // 로그인 & 세션 처리
                this.$api("/api/loginB2B", {
                  param: [
                    //bId: 접속자ID, bName: 접속자이름, bGrade: 작업레벨, admin: loginInfo.admin, alimCall: loginInfo.alimCall
                    { bId: loginInfo.handlerId, bName: loginInfo.handlerNameKor, bGrade: loginInfo.handlerGrade, alimCall: loginInfo.alimCall, 
                    divCode: loginInfo.divCd, compCode: loginInfo.compCode}
                  ]
                });
                this.$store.commit("user", loginInfo);
                localStorage.setItem('sessionExpiration', new Date().getTime() + ((60 * 60)*12) * 1000);

                // 1. checkNotice() 실행 및 완료 대기
                await this.checkNotice();

                // 2. 네비게이션 타겟 설정 후 조건부 페이지 이동
                this.navigationTarget = '/reserveInfoList_admin';
                this.handleNavigation();                
                
                // // 2. 팝업이 있을 경우 10초 대기
                // if (this.noticeModals.length > 0) {
                //   await new Promise(resolve => setTimeout(resolve, 10000));
                // }
                
                // // 3. 페이지 전환
                // this.$router.push('/reserveInfoList_admin');
              })
            }
          }
          else 
          {
            this.$refs.txt_bPass.select();
            this.$swal.fire({
              text: 'Password를 확인해주세요',
              icon: 'error'
            });
          }
        })
      }
    },

    // 공지사항 표시 처리 (쿠키 기능 제거)
    async checkNotice() {
      let checkNotice = await this.$api("/api/checkNotice_ma", {});
      console.log("checkNotice::::", checkNotice);

      if (checkNotice.length > 0) 
      {
        const newModals = checkNotice.map((notice) => ({
          id: notice.seqNotice,
          content: notice.nContent
        }));
        
        // 기존 배열을 완전히 비우고 새로운 데이터로 채우기
        this.noticeModals.splice(0, this.noticeModals.length, ...newModals);
      } 
      else 
      {
        // 데이터가 없으면 배열 비우기
        this.noticeModals.splice(0, this.noticeModals.length);
      }
      console.log("noticeModal:>>>>", this.noticeModals);
    },

    // 닫기 이벤트: 해당 인덱스의 팝업만 제거
    handleNoticeClose(idx) {
      this.noticeModals.splice(idx, 1);
    }
  }
}
</script>
